<template>
  <v-dialog v-model="dialog"
            @click:outside="closeDialog"
            max-width="600px"
  >
    <v-card>
      <v-toolbar dense :elevation="0">
        <v-toolbar-title class="text-primary-700">
          New Filter
        </v-toolbar-title>
        <div class="flex-grow-1"></div>
        <v-btn icon @click="closeDialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-divider></v-divider>
      <v-card-text style="height:500px; overflow-y: scroll;">
        <form>
          <h3 class="text-h7 mt-6 mb-0 pa-0">Deals</h3>
          <v-row>
            <v-col>
                <v-checkbox
                  :ripple="false"
                  v-model="form.showSales"
                  label="Show Sales"
                  hide-details
                ></v-checkbox>
                <v-checkbox
                  :ripple="false"
                  v-model="form.showLettings"
                  label="Show Lettings"
                ></v-checkbox>
            </v-col>
          </v-row>
          <h5 class="text-h7 mb-1 pa-0">Date Range</h5>
          <v-row>
            
            <v-col>
            <!-- <v-col cols="2" >
              <v-chip label>From</v-chip>
            </v-col>
            <v-col cols="4"> -->
              <v-text-field
                outlined
                dense
                hide-details
                v-model="form.from_date"
                label="From"
                hint="dd/mm/yyyy format"
                v-validate="'date_format:dd/MM/yyyy'"
                v-mask="'##/##/####'"
                append-icon="mdi-calendar"
                return-masked-value
                :disabled="!dealVCheck"
              ></v-text-field>
              
            </v-col>
            <!--<v-col cols="2">
              <v-chip label>to</v-chip>
            </v-col>
            <v-col cols="4"> -->
              <v-col cols="6">
              <v-text-field
                outlined
                dense
                hide-details
                v-model="form.to_date"
                hint="dd/mm/yyyy format"
                v-validate="'date_format:dd/MM/yyyy'"
                v-mask="'##/##/####'"
                append-icon="mdi-calendar"
                return-masked-value
                label="To"
                :disabled="!dealVCheck"
              ></v-text-field>
             </v-col>
          </v-row>
          <v-divider class="mt-8"></v-divider>
          <h3 class="text-h7 mt-8 mb-0 pa-0">Landlords</h3>
          
          <v-row class="mt-0">
            <v-col cols="6">
              
              <v-autocomplete
                v-model="form.landlordCompany"
                :loading="landlordCompanies.loading"
                :items="landlordCompanies.items"
                :search-input.sync="landlordCompanies.search"
                no-filter
                flat
                hide-no-data
                clearable
                hide-details
                outlined dense
                item-text="name"
                item-value="id"
                label="Landlord"
                return-object
              ></v-autocomplete>
            </v-col>
            <v-col cols="6">
              <v-autocomplete
                v-model="form.landlordAgentCompany"
                :loading="landlordAgentCompanies.loading"
                :items="landlordAgentCompanies.items"
                :search-input.sync="landlordAgentCompanies.search"
                no-filter
                flat
                hide-no-data
                clearable
                hide-details
                outlined dense
                item-text="name"
                item-value="id"
                label="Landlord Agent"
                return-object
              ></v-autocomplete>
            </v-col>
            <v-col cols="6">
              <v-autocomplete
                v-model="form.landlordContact"
                :loading="landlordContacts.loading"
                :items="landlordContacts.items"
                :search-input.sync="landlordContacts.search"
                no-filter
                flat
                hide-no-data
                clearable
                hide-details
                outlined dense
                item-text="name"
                item-value="id"
                label="Landlord Contact"
                return-object
              ></v-autocomplete>
            </v-col>
            <v-col cols="6">
              <v-autocomplete
                v-model="form.landlordAgentContact"
                :loading="landlordAgentContacts.loading"
                :items="landlordAgentContacts.items"
                :search-input.sync="landlordAgentContacts.search"
                no-filter
                flat
                hide-no-data           
                clearable
                outlined dense hide-details
                item-text="name"
                item-value="id"
                label="Landlord Agent Contact"
                return-object
              ></v-autocomplete>
            </v-col>
            
          </v-row>
          <v-divider class="my-8"></v-divider>
          <h3 class="text-h7 mt-8 mb-0 pa-0">Tenants</h3>
          
          <v-row class="mt-0">
            <v-col cols="12">
              
              <v-autocomplete
                v-model="form.tenantCompany"
                :loading="tenantCompanies.loading"
                :items="tenantCompanies.items"
                :search-input.sync="tenantCompanies.search"
                no-filter
                flat
                hide-no-data
                clearable
                outlined dense hide-details
                item-text="name"
                item-value="id"
                label="Tenant"
                hint="The trading name of the tenant. Leave blank if the property is vacant."
                persistent-hint
                return-object
              >
                <template v-slot:item="{ item }">
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ item.name }}
                      <v-tooltip bottom v-if="item.core_id">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                          small
                            :color="item.is_verified ? 'green' : 'orange lighten-1'"
                            v-bind="attrs"
                            v-on="on"
                          >
                            mdi-checkbox-marked-circle-outline
                          </v-icon>
                        </template>
                        <span v-if="item.is_verified">Verified Tracked Retailer</span>
                        <span v-else>This Tracked Retailer has not yet been Verified</span>
                      </v-tooltip>
                    </v-list-item-title>
                  </v-list-item-content>
                </template>
            </v-autocomplete>
            </v-col>
            <v-col cols="6">
              <v-autocomplete
                v-model="form.legalTenantCompany"
                :loading="legalTenantCompanies.loading"
                :items="legalTenantCompanies.items"
                :search-input.sync="legalTenantCompanies.search"
                no-filter
                flat
                hide-no-data
                clearable
                outlined dense hide-details
                item-text="name"
                item-value="id"
                label="Tenant (legal)"
                hint="Optionally set the company which is the legal tenant, if it is different."
                persistent-hint
                return-object
              ><template v-slot:item="{ item }">
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ item.name }}
                      <v-tooltip bottom v-if="item.core_id">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                          small
                            :color="item.is_verified ? 'green' : 'orange lighten-1'"
                            v-bind="attrs"
                            v-on="on"
                          >
                            mdi-checkbox-marked-circle-outline
                          </v-icon>
                        </template>
                        <span v-if="item.is_verified">Verified Tracked Retailer</span>
                        <span v-else>This Tracked Retailer has not yet been Verified</span>
                      </v-tooltip>
                    </v-list-item-title>
                  </v-list-item-content>
                </template></v-autocomplete>
            </v-col>
            <v-col cols="6">
              <v-autocomplete
                v-model="form.tenantContact"
                :loading="tenantContacts.loading"
                :items="tenantContacts.items"
                :search-input.sync="tenantContacts.search"
                no-filter
                flat
                hide-no-data
                clearable
                outlined dense hide-details
                item-text="name"
                item-value="id"
                label="Tenant Contact"
                return-object
              ></v-autocomplete>
            </v-col>
            <v-col cols="6">
              <v-autocomplete
                v-model="form.tenantAgent"
                :loading="tenantAgent.loading"
                :items="tenantAgent.items"
                :search-input.sync="tenantAgent.search"
                no-filter
                flat
                hide-no-data
                clearable
                outlined dense hide-details
                item-text="name"
                item-value="id"
                label="Tenant Agent"
                return-object
              ></v-autocomplete>         
            </v-col>
            <v-col cols="6">
              <v-autocomplete
                v-model="form.tenantAgentContact"
                :loading="tenantAgentContacts.loading"
                :items="tenantAgentContacts.items"
                :search-input.sync="tenantAgentContacts.search"
                no-filter
                flat
                hide-no-data
                clearable
                outlined dense hide-details
                item-text="name"
                item-value="id"
                label="Tenant Agent Contacts"
                return-object
              ></v-autocomplete>
            </v-col>
          </v-row>
          <v-divider class="my-8"></v-divider>
          <h3 class="text-h7 mt-8 mb-0 pa-0">Property</h3>
          
          <v-row class="mt-0">
            <!-- <v-col cols="2" class="pa-6">
              <v-chip label>and</v-chip>
            </v-col> -->
            <v-col cols="12">
              <v-select
                v-model="form.address_type"
                :items="addressTypes"
                label="Type"
                multiple
                outlined hide-details dense
                :menu-props="{
                    offsetY: true,
                }"
              ></v-select>
            </v-col>
          </v-row>
          <h5 class="text-h7 mb-1 mt-4 pa-0">Size Range</h5>
          <v-row>
            <v-col cols="6">
              <v-text-field
                outlined
                dense
                v-model="form.from_size"
                label="From (sqft)"
                hide-details
                append-icon="mdi-home"
                return-masked-value
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                outlined
                dense
                v-model="form.to_size"
                label="To (sqft)"
                hide-details
                append-icon="mdi-home"
                return-masked-value
              ></v-text-field>
            </v-col>
          </v-row>
          <!-- <v-row>
            <v-col cols="2" class="pa-4 py-6">
              <v-chip label>From</v-chip>
            </v-col>
            <v-col cols="4">
              <v-text-field
                v-model="form.from_size"
                type="number"
                label="Size"
              ></v-text-field>
            </v-col>
            <v-col cols="2" class="pa-6">
              <v-chip label>to</v-chip>
            </v-col>
            <v-col cols="4">
              <v-text-field
                v-model="form.to_size"
                type="number"
                label="Size"
              ></v-text-field>
            </v-col>
          </v-row> -->
          <v-divider class="my-8"></v-divider>
          <h3 class="text-h7 mb-0 pa-0">Pipelines</h3>
          
          <!-- pipeline name, client, contact, status, reason -->
          <v-row class="mt-0">
            <v-col cols="12">
              <v-autocomplete
                outlined
                dense
                hide-details
                
                v-model="form.pipeline"
                :loading="pipelines.loading"
                :items="pipelines.items"
                item-text="name"
                return-object
                :hide-no-data="pipelines.loading ? true : false"
                :menu-props="{
                    offsetY: true,
                }"
                hint="Select the pipeline to add the property to"
                persistent-hint
                required
                clearable
                hide-no-data
                label="Pipeline"
            ></v-autocomplete>
            </v-col>
            <v-col cols="6">
              <v-autocomplete
                outlined
                dense
                hide-details
                return-object
                v-model="form.pipeline_client"
                :items="client.items"
                :loading="client.loading"
                :search-input.sync="client.search"
                :item-title="item => item.label"
                :item-value="item => item.value"
                :item-text="'label'"
                hide-no-data
                label="Client"
              ></v-autocomplete>
            </v-col>
            <v-col cols="6">
              <v-autocomplete
                outlined
                dense
                hide-details
                return-object
                v-model="form.pipeline_contact"
                :items="contact.items"
                :loading="contact.loading"
                :search-input.sync="contact.search"
                :item-title="item => item.label"
                :item-value="item => item.value"
                :item-text="'label'"
                hide-no-data
                label="Contact"
              ></v-autocomplete>
            </v-col>
            <v-col cols="6">
              <v-select
                outlined
                dense
                hide-details
                v-model="form.pipeline_status"
                :items="statuses"
                :menu-props="{
                    offsetY: true,
                }"
                label="Status"
              ></v-select>
            </v-col>
            <v-col cols="6">
              <v-select
                outlined
                dense
                hide-details
                v-model="form.pipeline_reason"
                :items="reasons"
                :menu-props="{
                    offsetY: true,
                }"
                label="Reason"
              ></v-select>
            </v-col>
          </v-row>
          <v-divider class="my-8"></v-divider>
          <h3 class="text-h7 mb-0 pa-0">Tenancy</h3>
          <h5 class="text-h7 mb-1 mt-2 pa-0">Rent Range</h5>
          <v-row>
            <v-col cols="6">
              <v-text-field
                outlined
                dense
                hide-details
                v-model="form.from_rent"
                prefix="£"
                label="From"
                hint="£"
                return-masked-value
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                outlined
                dense
                hide-details
                v-model="form.to_rent"
                label="To"
                prefix="£"
                hint="£"
                return-masked-value
              ></v-text-field>
            </v-col>
          </v-row>
          <!-- <v-row>
            <v-col cols="2" class="pa-4 py-6">
              <v-chip label>From</v-chip>
            </v-col>
            <v-col cols="4">
              <v-text-field
                v-model="form.from_rent"
                type="number"
                label="Rent"
              ></v-text-field>
            </v-col>
            <v-col cols="2" class="pa-6">
              <v-chip label>to</v-chip>
            </v-col>
            <v-col cols="4">
              <v-text-field
                v-model="form.to_rent"
                type="number"
                label="Rent"
              ></v-text-field>
            </v-col>
          </v-row> -->

          <h5 class="text-h7 mb-1 mt-4 pa-0">Lease Expiry</h5>
          <v-row>
            <v-col cols="4">
              <v-select
              outlined dense hide-details
                v-model="form.lease_expire_type"
                :items="['before', 'after']"
                label="Lease expires"
              ></v-select>
            </v-col>
            <v-col cols="8">
              <v-text-field
                outlined
                dense
                hide-details
                v-model="form.lease_expire_date"
                label="Date"
                hint="dd/mm/yyyy format"
                persistent-hint
                v-validate="'date_format:dd/MM/yyyy'"
                :error-messages="errors.collect('form.lease_expire_date')"
                data-vv-name="form.lease_expire_date"
                data-vv-as="Date"
                v-mask="'##/##/####'"
                append-icon="mdi-calendar"
                return-masked-value
              ></v-text-field>
            </v-col>
          </v-row>

          <!-- <v-row>
            <v-col cols="3" class="pt-6">
              <v-chip label>Lease expires</v-chip>
            </v-col>
            <v-col cols="3">
              <v-select
                v-model="form.lease_expire_type"
                :items="['before', 'after']"
              ></v-select>
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-model="form.lease_expire_date"
                label="Date"
                hint="dd/mm/yyyy format"
                persistent-hint
                v-validate="'date_format:dd/MM/yyyy'"
                :error-messages="errors.collect('form.lease_expire_date')"
                data-vv-name="form.lease_expire_date"
                data-vv-as="Date"
                v-mask="'##/##/####'"
                return-masked-value
              ></v-text-field>
            </v-col>
          </v-row> -->


        </form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn depressed @click="closeDialog">Cancel</v-btn>
        <v-btn depressed :loading="loading" :disabled="!filtersApplied" color="primary" @click="save">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {mask} from 'vue-the-mask'

export default {
  name: "createLayerDialog",
  directives: {
    mask,
  },
  data: () => ({
    dialog: false,
    loading: false,
    form: {
      showSales: false,
      showLettings: false,
      from_date: '',
      to_date: '',
      
      tenantCompany: null,
      legalTenantCompany: null,
      landlordCompany: null,
      landlordAgentCompany: null,
      tenantContact: null,
      tenantAgent: null,
      tenantAgentContact: null,
      
      landlordContact: null,
      landlordAgentContact: null,
      // company_type: 'tenant',
      address_type: [],

      pipeline: null,
      pipeline_client: null,
      pipeline_contact: null,
      pipeline_status: null,
      pipeline_reason: null,

      from_size: '',
      to_size: '',
      from_rent: '',
      to_rent: '',
      lease_expire_type: 'before',
      lease_expire_date: '',
    },
    range: [null, null],
    markers: [],
    tenantCompanies: {
      loading: false,
      items: [],
      search: null,
    },
    legalTenantCompanies: {
      loading: false,
      items: [],
      search: null,
    },
    landlordCompanies: {
      loading: false,
      items: [],
      search: null,
    },
    landlordAgentCompanies: {
      loading: false,
      items: [],
      search: null,
    },
    tenantContacts: {
      loading: false,
      items: [],
      search: null,
    },
    landlordContacts: {
      loading: false,
      items: [],
      search: null,
    },
    landlordAgentContacts: {
      loading: false,
      items: [],
      search: null,
    },
    tenantAgent: {
      loading: false,
      items: [],
      search: null,
    },
    tenantAgentContacts: {
      loading: false,
      items: [],
      search: null,
    },
    client: {
      loading: false,
      items: [],
      search: null,
    },
    contact: {
      loading: false,
      items: [],
      search: null,
    },   
    pipelines:{
      loading: false,
      items: [],
      search: null,
    },
    // companyTypes: [{id: 'tenant', value: 'Tenant'},{id: 'landlord', value: 'Landlord'},{id: 'landlord_agent', value: 'Landlord agent'}],
    addressTypes: ['Leisure', 'Out of town', 'Shopping centres', 'Properties'],
    statuses: [
      { value: 'tbi', text: 'To Be Inspected'},
      { value: 'offer-submitted', text: 'Offer Submitted/Negotiating'},
      { value: 'with-solicitors', text: 'With Solicitors'},
      { value: 'exchanged', text: 'Exchanged'},
      { value: 'completed', text: 'Completed'},
    ],
    reasons: [
      { value: 'new-store', text: 'New Store'},
      { value: 'upsize', text: 'Upsize'},
      { value: 'downsize', text: 'Downsize'},
      { value: 'relocation', text: 'Relocation'},
      { value: 'disposal-closure', text: 'Disposal/Closure'},
    ]
  }),
  watch: {
    'tenantCompanies.search'(search) {
      if (!search) return;
      this.debounce(() => {
        this.getTenantCompanies();
      }, 375);
    },
    'legalTenantCompanies.search'(search) {
      if (!search) return;
      this.debounce(() => {
        this.getLegalTenantCompanies(search);
      }, 375);
    },
    'landlordCompanies.search'(search) {
      if (!search) return;
      this.debounce(() => {
        this.getLandlordCompanies(search);
      }, 375);
    },
    'landlordAgentCompanies.search'(search) {
      if (!search) return;
      this.debounce(() => {
        this.getLandlordAgentCompanies(search);
      }, 375);
    },
    'tenantContacts.search'(search) {
      if (!search) return;
      this.debounce(() => {
        this.getTenantContacts(search);
      }, 375);
    },
    'landlordContacts.search'(search) {
      if (!search) return;
      this.debounce(() => {
        this.getLandlordContacts(search);
      }, 375);
    },
    'landlordAgentContacts.search'(search) {
      if (!search) return;
      this.debounce(() => {
        this.getLandlordAgentContacts(search);
      }, 375);
    },
    'tenantAgent.search'(search) {
      if (!search) return;
      this.debounce(() => {
        this.getTenantAgents(search)
      }, 375);
    },
    'tenantAgentContacts.search'(search) {
      if (!search) return;
      this.debounce(() => {
        this.getTenantAgentContacts(search)
      }, 375);
    },
    'client.search'(search) {
      if (!search) return;
      this.debounce(() => {
        this.searchCompanies(search)
      }, 375);
    },
    'contact.search'(search) {
      if (!search) return;
      this.debounce(() => {
        this.getContacts(search)
      }, 375);
    },
  },
  computed: {
    dealVCheck() {
      return this.form.showSales || this.form.showLettings;
    },
    formValidated() {
      return Object.keys(this.fields).some(key => this.fields[key].validated)
        && Object.keys(this.fields).some(key => this.fields[key].valid);
    },
    filtersApplied() {
      return Object.entries(this.form).filter(([key, value]) => {
        // console.log(key, value)
        if (key === 'lease_expire_type') {
          return false;
        }
        if (Array.isArray(value)) {
          return value.length > 0;
        } else if (value) {
          return true;
        }

        return false;
      }).length > 0;
    },
  },
  methods: {
    showDialog: function () {
      this.dialog = true;
    },
    closeDialog: function () {
      this.dialog = false;
      this.clearForm();
      this.$emit('closed');
    },
    async save() {
      if (await this.$formValidator.validate(this.form)) {
        try {
          this.loading = true;
          let deal_type = [];
          if (this.form.showSales) {
            deal_type.push('sale');
          }
          if (this.form.showLettings) {
            deal_type.push('new_letting', 'subletting', 'lease_renewal', 'rent_review', 'tenant_change');
          }
          // format address type, for example Out Of Town needs to be out_of_town
          this.form.address_type = this.form.address_type.map(type => type.toLowerCase().replace(/ /g, '_'));
          const params = {
            deal_type: deal_type,
            deal_from_date: this.form.from_date ? this.formatDate(this.form.from_date) : null,
            deal_to_date: this.form.to_date ? this.formatDate(this.form.to_date) : null,
            tenant_company_id: this.form.tenantCompany ? this.form.tenantCompany.id : null,
            legal_tenant_company_id: this.form.legalTenantCompany ? this.form.legalTenantCompany.id : null,
            landlord_company_id: this.form.landlordCompany ? this.form.landlordCompany.id : null,
            landlord_agent_company_id: this.form.landlordAgentCompany ? this.form.landlordAgentCompany.id : null,
            tenant_contact_id: this.form.tenantContact ? this.form.tenantContact.id : null,
            landlord_contact_id: this.form.landlordContact ? this.form.landlordContact.id : null,
            landlord_agent_contact_id: this.form.landlordAgentContact ? this.form.landlordAgentContact.id : null,
            tenant_agent_id: this.form.tenantAgent ? this.form.tenantAgent.id : null,
            tenant_agent_contact_id: this.form.tenantAgentContact ? this.form.tenantAgentContact.id : null,
            address_type: this.form.address_type ? this.form.address_type : null,
            from_size: this.form.from_size ? this.form.from_size : null,
            to_size: this.form.to_size ? this.form.to_size : null,
            from_rent: this.form.from_rent ? this.form.from_rent : null,
            to_rent: this.form.to_rent ? this.form.to_rent : null,
            pipeline_id: this.form.pipeline ? this.form.pipeline.id : null,
            pipeline_client_id: this.form.pipeline_client ? this.form.pipeline_client.value : null,
            pipeline_contact_id: this.form.pipeline_contact ? this.form.pipeline_contact.value : null,
            pipeline_status: this.form.pipeline_status ? this.form.pipeline_status : null,
            pipeline_reason: this.form.pipeline_reason ? this.form.pipeline_reason : null,
            lease_expire_type: this.form.lease_expire_type,
            lease_expire_date: this.formatDate(this.form.lease_expire_date),
            include: 'entity'
          };
          // const response = await this.$http.post('/users', this.form)
          const response = await this.$http.get('/map/layer/coordinates', {
            params: params
          });
          this.loading = false;
          let layer = this.getLayer(response.data.data, params)
          // remove 
          this.$emit('created', layer);
          this.closeDialog();
        } catch (e) {
          this.$validationException(e)
          this.loading = false;
        }
      }
    },

    getLayer(markers, params) {
      return {
        deal_type: this.form.showSales ? 'Sales' : 'Lettings',
        deal_from_date: this.form.from_date,
        deal_to_date: this.form.to_date,
        companies_text: this.getLayerItemCompaniesText(),
        address_type: this.form.address_type,
        from_size: this.form.from_size,
        to_size: this.form.to_size,
        from_rent: this.form.from_rent,
        to_rent: this.form.to_rent,
        lease_expire_type: this.form.lease_expire_type,
        lease_expire_date: this.form.lease_expire_date,
        filters_text: this.getLayerItemFiltersText(),
        address_type_text: this.getLayerItemTypeText(),
        deal_text: this.getLayerItemDealsText(),
        pipeline: this.form.pipeline,
        pipeline_client: this.form.pipeline_client,
        pipeline_contact: this.form.pipeline_contact,
        pipeline_status: this.form.pipeline_status,
        pipeline_reason: this.form.pipeline_reason,

        params: params,
        amount: markers.length,
        markers: markers,
      };
    },
    getLayerItemFiltersText() {
      let filters = [];
      if (this.form.showSales) {
        filters.push('Sales');
      }
      if (this.form.showLettings) {
        filters.push('Lettings');
      }

      
      if (this.form.from_size !== '') {
        filters.push('Size min: ' + this.form.from_size);
      }
      if (this.form.to_size !== '') {
        filters.push('Size max: ' + this.form.to_size);
      }
      if (this.form.from_rent !== '') {
        filters.push('Rent min: ' + this.form.from_rent);
      }
      if (this.form.to_rent !== '') {
        filters.push('Rent max: ' + this.form.to_rent);
      }
      
    
      if (this.form.from_date && this.form.to_date) {
        filters.push('Deals Between: ' + this.form.from_date + ' - ' + this.form.to_date);
      }
      else if (this.form.from_date) {
        filters.push('Deal Start: ' + this.form.from_date);
      }
      else if (this.form.to_date) {
        filters.push('Deal End: ' + this.form.to_date);
      }

      if (this.form.lease_expire_date) {
        filters.push('Lease expires ' + this.form.lease_expire_type + ' ' + this.form.lease_expire_date);
      }

      if (this.form.pipeline) {
        filters.push('Pipeline: ' + this.form.pipeline.name);
      }
      if (this.form.pipeline_client) {
        filters.push('Client: ' + this.form.pipeline_client.label);
      }
      if (this.form.pipeline_contact) {
        filters.push('Contact: ' + this.form.pipeline_contact.label);
      }
      if (this.form.pipeline_status) {
        filters.push('Status: ' + this.form.pipeline_status);
      }
      if (this.form.pipeline_reason) {
        filters.push('Reason: ' + this.form.pipeline_reason);
      }

      return filters.join(', ')
    },
    getLayerItemTypeText() {
      // format, change out_of_town to Out Of Town for example
      let addressTypes = this.form.address_type.map(type => type.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase()));
      return addressTypes.length > 1 ? 'Types: ' + addressTypes.join(', ') : addressTypes.length > 0 ? 'Type: ' + addressTypes[0] : '';
    },
    getLayerItemCompaniesText() {
      let companyNames = [];
      if (this.form.tenantCompany) {
        companyNames.push('T:' + this.form.tenantCompany.name);
      }
      if (this.form.landlordCompany) {
        companyNames.push('L:' + this.form.landlordCompany.name);
      }
      if (this.form.landlordAgentCompany) {
        companyNames.push('LL:' + this.form.landlordAgentCompany.name);
      }
      if (this.form.legalTenantCompany) {
        companyNames.push('LT:' + this.form.legalTenantCompany.name);
      }
      if(this.form.tenantContact) {
        companyNames.push('TC:' + this.form.tenantContact.name);
      }
      if(this.form.landlordContact) {
        companyNames.push('LC:' + this.form.landlordContact.name);
      }
      if(this.form.landlordAgentContact) {
        companyNames.push('LAC:' + this.form.landlordAgentContact.name);
      }
      if(this.form.tenantAgent) {
        companyNames.push('TA:' + this.form.tenantAgent.name);
      }
      if(this.form.tenantAgentContact) {
        companyNames.push('TAC:' + this.form.tenantAgentContact.name);
      }
      return companyNames.join(', ')
    },

    getLayerItemDealsText() {

    },

    clearForm() {
      this.form = {
        tenantCompany: null,
        legalTenantCompany: null,
        landlordCompany: null,
        landlordAgentCompany: null,
        tenantContact: null,
        landlordContact: null,
        landlordAgentContact: null,
        tenantAgent: null,
        tenantAgentContact: null,
        address_type: [],
        from_size: '',
        to_size: '',
        from_rent: '',
        to_rent: '',
        lease_expire_type: 'before',
        lease_expire_date: '',
      };
      this.$validator.reset();
    },
    async getTenantCompanies() {
      const response = await this.$http.get('/companies/', {
        params: {
          q: this.tenantCompanies.search,
          per_page: 100,
        }
      });
      this.tenantCompanies.items = response.data.data;
    },
    async getLegalTenantCompanies() {
      const response = await this.$http.get('/companies/', {
        params: {
          q: this.legalTenantCompanies.search,
          per_page: 100,
        }
      });
      this.legalTenantCompanies.items = response.data.data;
    },
    async getLandlordCompanies() {
      const response = await this.$http.get('/companies/', {
        params: {
          q: this.landlordCompanies.search,
          per_page: 100,
        }
      });
      this.landlordCompanies.items = response.data.data;
    },
    async getLandlordAgentCompanies() {
      const response = await this.$http.get('/companies/', {
        params: {
          q: this.landlordAgentCompanies.search,
          per_page: 100,
        }
      });
      this.landlordAgentCompanies.items = response.data.data;
    },
    async getTenantContacts() {
      const response = await this.$http.get('/users/', {
        params: {
          q: this.tenantContacts.search,
          per_page: 100,
        }
      });
      this.tenantContacts.items = response.data.data;
    },
    async getLandlordContacts() {
      const response = await this.$http.get('/users/', {
        params: {
          q: this.landlordContacts.search,
          per_page: 100,
        }
      });
      this.landlordContacts.items = response.data.data;
    },
    async getLandlordAgentContacts() {
      const response = await this.$http.get('/users/', {
        params: {
          q: this.landlordAgentContacts.search,
          per_page: 100,
        }
      });
      this.landlordAgentContacts.items = response.data.data;
    },
    async getTenantAgents(search) {
      const response = await this.$http.get('/companies/', {
        params: {
          q: search,
          per_page: 100,
        }
      });
      this.tenantAgent.items = response.data.data;
    },
    async getTenantAgentContacts(search) {
      const response = await this.$http.get('/users/', {
        params: {
          q: search,
          per_page: 100,
          include: 'company',
        }
      });
      this.tenantAgentContacts.items = response.data.data;
    },

    searchCompanies(prop){
        this.client.loading = true
        this.getCompanies(prop)
    },

    searchContacts(prop){
        this.contact.loading = true
        this.getContacts(prop)
    },

    async getCompanies(prop){
      this.$http.get("/companies",{
          params: {
              q: prop,
              per_page: 50,
          }
      }).then(response => {
          this.client.items = response.data.data.map(company => {
              return {
                  value: company.id,
                  label: company.name,
              }
          })
          this.client.loading = false
      }).catch(error => {
          this.client.loading = false
      })
    },

    async getContacts(prop){
        this.$http.get("/users",{
            params: {
                q: prop,
                per_page: 50,
            }
        }).then(response => {
            this.contact.items = response.data.data.map(contact => {
                return {
                value: contact.id,
                label: contact.name,
                }
            })
            this.contact.loading = false
        }).catch(error => {
            this.contact.loading = false
        })
    },

    async getPipelines() {
      await this.$http.get("/pipelines",{
      }).then(response => {
          this.pipelines.items = response.data.data
          this.pipelines.loading = false
      }).catch(error => {
          console.log(error)
          this.pipelines.loading = false
      })
    },

    fillPipeline(pipeline){
        this.pipeline = pipeline
        this.pipelines.items.push(pipeline)
    },

    debounce(fn, delay) {
      
      clearTimeout(this._timerId)
      this._timerId = setTimeout(() => {
        fn();
      }, delay);
    },

    formatDate(date) {
      if (!date) return null

      const [day, month, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
  },
  mounted(){
      this.getPipelines()
  },

}
</script>

<style scoped>

</style>
